import { render, staticRenderFns } from "./TaskAccept.vue?vue&type=template&id=46604909&scoped=true&"
import script from "./TaskAccept.vue?vue&type=script&lang=js&"
export * from "./TaskAccept.vue?vue&type=script&lang=js&"
import style0 from "./TaskAccept.vue?vue&type=style&index=0&id=46604909&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46604909",
  null
  
)

export default component.exports